import { Button, Container, Grid, Typography, Box, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import OldPaper from '../components/paper/OldPaper'
import React from 'react'
import LocalStorage from '../local_storage/LocalStorage';
import AppCtx from '../contexts/app_context';
import Messages from '../components/messages/Messages'
import Icon from '../components/icon/Icon';
import { playAudio, wait } from '../utils/AsyncUtil';
import ChatBox from '../components/messages/ChatBox';
import { AMERICAN, BRITISH } from '../constants/missionIntro';
import { GREEN, ORANGE, RED } from '../style/colors';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import LoopOutlinedIcon from '@material-ui/icons/LoopOutlined';
import Spin from '../components/annimation/Spin';
import { ABORT_MISSION } from '../constants/abortMission';
import debug from '../utils/debugging'
const useStyles = makeStyles((theme) => ({
  inputArea: {
    width: '100%'
  },
  game: {
    width: '100%',
    height: `${window.innerHeight - 56}px`,
    display: 'flex',
    flexDirection: 'column',
    // alignContent: 'stretch',
  },
  message_area: {
    paddingTop: '1rem',
    paddingBottom: '1rem',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column-reverse',
    flexGrow: 10,
    height: '300px',
  },
  bar: {
    flexGrow: 0
  },
  options: {
    flexGrow: 0,
    height: '200px',
    minHeight: '200px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },

  option: {
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    fontSize: '1.05rem',
    backgroundColor: '#fff',
    borderBottom: '1px solid lightgray',
  },

  mission_option: {
    // paddingLeft:'',
    // paddingRight:'3rem',
  },

  no_options: {
    backgroundColor: theme.palette.secondary.main,
    backgroundImage: 'url(rev1.jpg)',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    color: theme.palette.primary.main,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    fontSize: '1rem',
  },

  reload_button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    borderRadius: "40rem",
  }

}));



// ---------------------- UserInput -----------------------

function SendButton({ report, disabled }) {
  return <Button
    onClick={report}
    disabled={disabled}
    fullWidth
    variant="contained"
    color="secondary"

  >
    {/* Using png image for icon is probbably to slow, should switch to svg */}
    <Icon width='50px' height='24px' src='PRIcon.png' alt='Send' />
    send
  </Button>
}

function UserInput({
  report,
  selected_option,
  options_avaliable,
  callServer,
  setShowOptions,
  report_params

}) {


  const [calling_server, setCallingServer] = React.useState(false)

  // const callToServer = () => {
  //   setCallingServer(true)
  //   callServer(report_params).then(() => setCallingServer(false))
  // }

  const callReport = async () => {
    setCallingServer(true)
    setShowOptions(false)
    await report(report_params)
    setCallingServer(false)
    setShowOptions(true)
  }


  const InputSwitch = () => {
    // render the sender is an option is selected
    if (Object.keys(selected_option).length > 0) {
      return <Grid container alignItems="center">
        <SendButton report={callReport} disabled={calling_server} />
      </Grid>
    }
    // else render one of the two options here
    // using this switch is a little bit dangoursus because the order matters.
    // for need_data to ever get hit, options_avaliable needs to be false. 
    // This is ok since if we have options then we dont need more data, but it could 
    // make debugging hard in the future. 
    switch (true) {
      // case options_avaliable:
      default:
        // hides or shows the options the user can choose
        return <Grid container alignItems="center">
          {calling_server
            ? <SendButton report={callReport} disabled={true} />
            : <Button fullWidth
              variant="contained"
              color="secondary">
              Select {report_params.is_mission ? 'a Mission' : 'an Option'}
            </Button>}
        </Grid>
    }
  }

  return <div>
    <InputSwitch />
  </div>
}

function Option({ children, selected_option, value, onClick }) {
  const text = children
  const selected_id = selected_option.id
  const id = value.id
  const css = useStyles()
  return <Container
    className={`${css.option}`}
    style={{ backgroundColor: selected_id === id ? '#cff0cc' : 'white' }}
    onClick={() => selected_id === id
      ? onClick({})
      : onClick(value)
    }
  >
    {text}
  </Container>
}

/**
 * Gets the number code for the amount of positions available
 * @param {int} active_spies number of spies activly doing the mission
 * @param {int} spy_limit number of spies allowed for mission
 * @returns hexadeciaml number for color code
 */
function getNumberOfPositionColor(active_spies, spy_limit) {
  const prct = active_spies / spy_limit
  switch (true) {
    case prct < 0.5:
      return GREEN
    case prct < 0.7:
      return ORANGE
    default:
      return RED
  }
}

function MissionOption({ selected_option, value, onClick }) {
  // debug.log('in mission options---------->')
  const selected_id = selected_option.mission
  const id = value.mission
  const spy_limit = value.spy_limit
  const active_spies = value.active_spies || 0
  const css = useStyles()
  const is_selected = selected_id === id ? true : false

  return <Container
    className={`${css.option} ${css.mission_option}`}
    style={{ backgroundColor: is_selected ? '#cff0cc' : 'white' }}
    onClick={() => is_selected ? onClick({}) : onClick(value)}
  >
    <Typography variant="subtitle2" gutterBottom>
      {value.mission_name}
    </Typography>
    <Typography variant="body2" paragraph>
      {(value.description.length > 100) && !is_selected
        ? value.description.slice(0, 100) + '...'
        : value.description}
    </Typography>
    <Typography
      variant="body2"
      style={{ color: getNumberOfPositionColor(active_spies, spy_limit) }}
    >
      <i>{spy_limit - active_spies} positions of {spy_limit} avaliable </i>
    </Typography>
  </Container>
}


function OptionSelect(props) {
  return <div>
    {props.children}
  </div>
}



// ---------------------- Game ----------------------------
const addMessage = (text, audio = null, bool = false) => {
  return { message: text, sent: bool, audio: audio }
}

function useMessageHistory(user) {
  const KEY = 'messages'
  const [message_history, setMessageHistory] = useInitUserLocalStorage(user, KEY, [])
  return [message_history, data => {
    const current_user = LocalStorage.get('users')[user.agent_name]
    current_user[KEY].push(data)
    LocalStorage.updateUserData(current_user)
    setMessageHistory(current_user[KEY])
  }]
}

function useMissionsLocalStorage(user) {
  const KEY = 'missions'
  const [mission, setMission] = useInitUserLocalStorage(user, KEY, [])
  return [mission, resp => {
    const current_user = LocalStorage.get('users')[user.agent_name]
    current_user[KEY] = resp
    LocalStorage.updateUserData(current_user)
    setMission(current_user[KEY] || [])
  }]
}

function useTaskLocalStorage(user) {
  const KEY = 'task'
  const [task, setTask] = useInitUserLocalStorage(user, KEY, {})
  return [task, resp => {
    const current_user = LocalStorage.get('users')[user.agent_name]
    current_user[KEY] = resp
    LocalStorage.updateUserData(current_user)
    setTask(current_user[KEY] || {})
  }]
}

function useOptionLocalStorage(user) {
  const KEY = 'option'
  const [option, setOption] = useInitUserLocalStorage(user, KEY, {})
  return [option, resp => {
    const current_user = LocalStorage.get('users')[user.agent_name]
    current_user[KEY] = resp
    LocalStorage.updateUserData(current_user)
    setOption(current_user[KEY] || {})
  }]
}

function useInitUserLocalStorage(user, key, default_value) {
  const current_user = getCurrentUser(user)
  if (!current_user[key]) {
    current_user[key] = default_value
    LocalStorage.updateUserData(current_user)
  }
  return React.useState(current_user[key])
}

function useUserLocalStorageState(key, default_value) {
  const { user } = React.useContext(AppCtx)
  const current_user = getCurrentUser(user)

  if (!current_user[key]) {
    current_user[key] = default_value
    LocalStorage.updateUserData(current_user)
  }
  const [data, setData] = React.useState(current_user[key])
  return [data, arg => {
    const current_user = LocalStorage.get('users')[user.agent_name]
    current_user[key] = arg
    LocalStorage.updateUserData(current_user)
    setData(current_user[key])
  }]
}

function getCurrentUser(user) {
  return LocalStorage.get('users')[user.agent_name]
}

async function getTask(params, callback) {
  let json = {}
  if (params.is_mission) {
    // requesting a task with only mission data
    debug.log('getTask ,mission, params', params)
    json = {
      next_task_id: null,
      current_task_id: null,
      current_operation_id: params.selected_option.operation,
      current_mission_id: params.selected_option.mission,
    }
  } else {
    // requesting a task with only task data
    const next_task_id_arr = params.selected_option.next_task || []
    json = {
      next_task_id: next_task_id_arr[0],
      current_task_id: params.task_current.id,
      current_operation_id: params.task_current.operation || 'recVbF6bdwQuYR6I8',
      current_mission_id: params.task_current.mission || 'recOF8oDloNjGqx1l',
    }
  }
  json.user_id = params.user_id
  json = JSON.stringify(json)
  const encode_data = encodeURI(json)
  const request =
    `https://sgm04hgy41.execute-api.us-west-1.amazonaws.com/prod/task?data=${encode_data}`
  const resp = await fetch(request)
  let data = await resp.json()
  await callback(data)
}

async function getMissions(user) {
  // connot put the entire user on as that will be to much data
  const json = JSON.stringify({
    user: {
      allegiance: user.allegiance,
      age: user.age,
    }
  })
  const encoded_data = encodeURI(json)
  const request =
    `https://sgm04hgy41.execute-api.us-west-1.amazonaws.com/prod/spy-missions?data=${encoded_data}`
  try {
    const resp = await fetch(request)
    return await resp.json()
  } catch (e) {
    alert('there was an error wile loading new missions, refresh the page.')
    // handle error well so the app does not crash or get stuck for the user
  }
}




export default function Game() {
  const { user, setMustStayInGame } = React.useContext(AppCtx)
  const [message_history, addMessageHistory] = useMessageHistory(user)
  const [missions, setMissions] = useMissionsLocalStorage(user)
  const [task_current, setTaskCurrent] = useTaskLocalStorage(user)
  const [option, setOption] = useOptionLocalStorage(user)
  const [show_options, setShowOptions] = useUserLocalStorageState(
    'show_options',
    missions.length ? true : false,
  )
  const outcomes = task_current.outcome || []
  const mission_is_selected = task_current.id ? true : false
  const css = useStyles()

  const [is_typing, setIsTyping] = React.useState(false)
  const [mounted, setMounted] = React.useState(false)
  const [audio_playing, setAudioPlaying] = React.useState(false)

  /**
   * plays the audio. Sets state so we can make sure other audio wont play.
   * awaitable.
   * @param {string} audio_url the url to the audio file
   */
  const playAudioWithState = React.useCallback(async audio_url => {
    if (user.auto_play_audio) {
      await wait(250);
      const a = new Audio(audio_url.replaceAll('"', ''))
      setAudioPlaying(true)
      await playAudio(a)
      setAudioPlaying(false)
    }
  }, [user])

  // call this to update mission. should happen every time a mission ends
  const getMissionUpdates = React.useCallback(async () => {
    const resp = await getMissions(user)
    setMissions(resp.missions)
    // reset tasks, there is no current task if we just called for missions
    setTaskCurrent({})
  }, [setMissions, setTaskCurrent, user])

  const callGetMissionsInit = React.useCallback(async () => {
    // get new missions
    await getMissionUpdates()

    // handle British or american Introductions
    if (!message_history.length) {
      let text = ''
      let audio_url = ''
      if (user.allegiance === 'British') {
        // use british intro
        text = BRITISH.text
        audio_url = BRITISH.audio
      } else {
        // use american intro
        text = AMERICAN.text
        audio_url = AMERICAN.audio
      }
      addMessageHistory(addMessage(text, audio_url, false))
      await playAudioWithState(audio_url)
    }
    setShowOptions(true)
  }, [
    getMissionUpdates,
    setShowOptions,
    addMessageHistory,
    user,
    playAudioWithState,
    message_history.length
  ])


  React.useEffect(() => {
    const getData = async () => {
      await callGetMissionsInit()
    }
    if (!mounted && missions.length === 0) {
      setMounted(true)
      getData()
    }
  }, [mounted, callGetMissionsInit, missions])

  const waitWhileCulperIsTyping = async (text) => {
    setIsTyping(true)
    const words_time = text.split(' ').length * 250
    const ms = words_time > 7000 ? 7000 : words_time
    await wait(ms)
    setIsTyping(false)
  }

  // TODO: Refactor, this method would confuse anyone who does not understand
  // async programming very well. mixing callbacks with awaits is confusing. 
  const _callServer = params => {
    setMustStayInGame(true)
    const promise = getTask(params, async resp => {
      const current_task = resp
        && resp.id // check if there is an ID, if there is no ID then this resp will not be a full current task
        && resp.mission_complete
        && !resp.mission_not_available // mission is avalaible, ie there are not to many users already using it
        ? {} : resp
      debug.log('current task from callServer', current_task)
      if (current_task.id) {
        await waitWhileCulperIsTyping(current_task.description)
        addMessageHistory(addMessage(current_task.description, current_task.audio, false))
        setTaskCurrent(resp)

        // play audio
        if (current_task.audio) {
          debug.log('auto play audio!')
          await playAudioWithState(current_task.audio)
        }
      } else {
        // there are no more tasks to do. This could hapen because:
        // - the user has finished all of the tasks in a mission
        // - the mission is no longer available
        if (resp.mission_not_available) {
          alert('Sorry, this mission is no longer available. Please select a different one.')
        }
        if (resp.agent_status === 'kicked') {
          debug.log(resp)
          alert('You have been kicked from the mission.')
        }
        await getMissionUpdates()
        await setMustStayInGame(false)
      }
    })
    return promise
  }

  const report = async (params) => {
    // if user is selecting mission, then the descript is comming from culper
    let added_message
    setMustStayInGame(true)
    if (params.is_mission) {
      added_message =
        addMessage(
          `I have selected this mission: ${params.selected_option.mission_name}`,
          null,
          true,
        )
      addMessageHistory(added_message)
    } else {
      added_message = addMessage(params.selected_option.description, null, true)
      addMessageHistory(added_message)
    }
    setOption({}) // remove what the user selected

    // display the response if avaliable locally 
    if (params.selected_option.response) {
      await setShowOptions(false)
      const { selected_option } = params
      let text = ''
      let audio_link = ''
      
      if (selected_option.id === 'abort_mission') {
        // handle abort mission resp
        const arr_abort_resps = selected_option.response[user.allegiance.toLowerCase()]
        const abort_resp =
          arr_abort_resps[Math.floor(Math.random() * arr_abort_resps.length)]
        text = abort_resp.text
        audio_link = abort_resp.audio
        await waitWhileCulperIsTyping(text)
      } else {
        // handle normal task complete response 
        text = selected_option.response
        audio_link = selected_option.audio
        await waitWhileCulperIsTyping(text)
      }

      addMessageHistory(addMessage(text, audio_link, false))
      if (audio_link) {
        await playAudioWithState(audio_link)
      }

    }
    await _callServer(params)
    await setMustStayInGame(false)
  }

  // wrapper for mission options to keep the render easy to read
  function MissionOptions() {
    return missions.map(x => {
      x.active_spies = x.active_spies || 0
      if (x.active_spies >= x.spy_limit) {
        return <span key={x.mission} />
      }
      return (
        <MissionOption
          onClick={setOption}
          key={x.mission}
          selected_option={option}
          value={x}
        />
      )
    })
  }

  function ReloadMissions() {
    const [is_calling, setIsCalling] = React.useState(false)
    const callServer = async () => {
      setIsCalling(true)
      // this calls a rerender in the parent component (Game) which means we 
      // do not need to set this value to false after it finishes. 
      // therefor, we will not await this call
      getMissionUpdates()
    }
    return <Box
      style={{
        position: 'absolute',
        bottom: '5px',
        right: '10px',
      }}>
      <Spin disabled={!is_calling}>
        <IconButton disabled={is_calling} onClick={is_calling ? () => { } : callServer}>
          <LoopOutlinedIcon color="primary" style={{ fontSize: "2rem" }} />
        </IconButton>
      </Spin>
    </Box>
  }

  // render 
  return <div className={css.game}>
    <OldPaper className={css.message_area}>
      <Container>
        <Messages
          data={message_history}
          audio_playing={audio_playing}
          setAudioPlaying={setAudioPlaying}
        />
        <ChatBox is_typing={is_typing} />
      </Container>
    </OldPaper>
    <UserInput
      report={report}
      selected_option={option}
      need_data={task_current.id ? false : true}
      options_avaliable={outcomes.length && task_current.id ? true : false}
      callServer={_callServer}
      setShowOptions={setShowOptions}
      show_options={show_options}
      report_params={{
        user_id: LocalStorage.getUserUniqueID(user), // TODO: use real ID 
        task_current: task_current,
        selected_option: option,
        is_mission: !mission_is_selected
      }}
    />
    <div className={css.options} >
      {show_options ?
        <OptionSelect >
          {mission_is_selected
            ? <>
              {outcomes.map(x => (
                <Option onClick={setOption} key={x.id} selected_option={option} value={x}>
                  {x.description}
                </Option>
              ))}
              <Option
                onClick={setOption}
                key={ABORT_MISSION.id}
                selected_option={option}
                value={ABORT_MISSION}
              >
                {ABORT_MISSION.description}
              </Option>
            </> : <Box
              m={1}
              css={{ height: '180px' }}
            >
              {missions.length
                ? <MissionOptions />
                : <NoMissions />}
              <ReloadMissions />
            </Box>
          }

        </OptionSelect>
      : <NoOptions />}
    </div>
  </div>

}

function NoOptions() {
  let random_int = React.useRef()
  React.useEffect(() =>
    random_int.current = Math.floor(Math.random() * 8),
    [random_int]
  )
  return <div style={{
    backgroundImage: `url(no_option_imgs/rev${random_int.current}.png)`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    fontSize: '1rem',
  }} />
}

function NoMissions() {
  return <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    bgcolor="background.paper"
    p={4}
    css={{ height: '100%' }}
  >
    <Box p={1}>
      <SentimentVeryDissatisfiedIcon
        color="primary"
        style={{ fontSize: '5rem' }}
      />
    </Box>
    <Box p={1}>
      <Typography component="div" style={{ fontSize: "1.15rem" }}>
        Sorry, there are no missions currently avaliable. <br />
        Tap <LoopOutlinedIcon color="primary" style={{
          position: 'relative',
          top: '6px'
        }} />  to get an update.

      </Typography>
    </Box>
  </Box>
}


